import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { CognitoService } from '@app/services/cognito.service';

@Injectable({
  providedIn: 'root',
})
export class AnonymousGuard implements CanActivate {
  constructor(private cognitoService: CognitoService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    if (this.router.getCurrentNavigation().id === 1) {
      // prevent '/register' and '/sign-in' routes to be directly accessed
      this.router.navigate(['/']);
      return false;
    }
    return this.cognitoService.isSessionValid().pipe(
      map((isValid) => {
        if (!isValid) {
          return true;
        }
        this.router.navigate(['/']);
        return false;
      })
    );
  }
}
